module.exports = __webpack_public_path__ + "static/media/Talq-coming.958a49ae.jpg";